import { defineStore } from "pinia";

import analyticsStoreLogic from "./analyticsStore";
import dumpStoreLogic from "./dumpStore";
import userStoreLogic from "./userStore";
import stripeStoreLogic from "./stripeStore";
import reviewersStoreLogic from "./reviewersStore";
import reviewStoreLogic from "./reviewStore";
import localStorageStoreLogic from "./localStorageStore";
import quickBooksStoreLogic from "./qbStore";
import tableLogic from "./tableStore";
import { usePinStore } from "./pinStore";

export const useAnalytics = defineStore("analytics", analyticsStoreLogic);
export const useDump = defineStore("dump", dumpStoreLogic);
export const useUser = defineStore("user", userStoreLogic);
export const useStripe = defineStore("stripe", stripeStoreLogic);
export const useReviewers = defineStore("reviewers", reviewersStoreLogic);
export const useReview = defineStore("review", reviewStoreLogic);
export const useLocalStorage = defineStore(
  "localStorage",
  localStorageStoreLogic
);
export const useQb = defineStore("qb", quickBooksStoreLogic);
export const useTable = defineStore("table", tableLogic);
export { usePinStore };
